module.exports = __webpack_public_path__ + "static/media/CU.2d3bcbec.svg";